import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import Flex from 'components/Layout/components/Flex';

const BasketMessageContainer = styled(Flex.Row)`
    padding: ${Spacing8};
`;

export default BasketMessageContainer;
